<template>
    <form :id="id" @submit.prevent="handleSubmit">
        <fieldset :disabled="disabled">
            <x-form-group
                label="Batch Upload"
                :horizontal="false"
                :isRequired="true"
            >
                <x-input-translation-upload-batch
                    v-model="fields.batch_id"
                    :disabled="Boolean(initialFields.batch_id)"
                />
            </x-form-group>

            <x-form-group label="Label" :horizontal="false" :isRequired="true">
                <input
                    type="text"
                    class="form-control"
                    v-model="fields.title"
                    required
                />
            </x-form-group>

            <x-form-group
                label="Sub Label"
                :horizontal="false"
                :isRequired="false"
            >
                <input
                    type="text"
                    class="form-control"
                    v-model="fields.subtitle"
                />
            </x-form-group>

            <x-form-group
                label="Konten Asli"
                :error="getError('original_content')"
                :is-required="true"
                :horizontal="false"
            >
                <x-input-editor
                    v-model="fields.original_content"
                    :readonly="disabled || readonly"
                />
            </x-form-group>

            <x-form-group
                label="Hasil Translate"
                :error="getError('translated_content')"
                :is-required="false"
                :horizontal="false"
            >
                <x-input-editor
                    v-model="fields.translated_content"
                    :readonly="disabled || readonly"
                />
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XFormGroup from "../../components/XFormGroup.vue";
import XInputEditor from "../../components/XInputEditor.vue";
import XInputTranslationUploadBatch from "../../components/XInputTranslationUploadBatch.vue";
import FormDataMixin from "../../mixins/FormDataMixin";
import FormErrorMixin from "../../mixins/FormErrorMixin";
import PropertySyncMixin from "../../mixins/PropertySyncMixin";

export default {
    components: {
        XFormGroup,
        XInputTranslationUploadBatch,
        XInputEditor,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
        this.initialStatus = this.fields.status;
    },
    data() {
        return {
            fields: {
                batch_id: null,
                title: null,
                subtitle: null,
                original_content: null,
                translated_content: null,
            },
            isLoading: false,
        };
    },
    methods: {
        handleSubmit() {
            const formData = this.buildFormData(this.fields);
            this.$emit("submit", formData);
        },
    },
    mixins: [FormDataMixin, FormErrorMixin, PropertySyncMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>
